import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalUpdateChild from "./ModalUpdateChild";

const useModalUpdateChild = (onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, mode: 'none', child_id: null })  ;

    const onClickActivate = ( child_id, mode) =>
    {
        setDialog ({ openState: true, child_id: child_id, mode: mode});
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, user_id: null, key: null, mode: 'none'});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, user_id: null, mode: 'none'});

        // Tell the parent we're done
        onSaveCompleted() ;
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalUpdateChild child_id={dialog.child_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalUpdateChild ;
